import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Gruppo } from 'src/app/models/gruppo';
import { Incarico } from 'src/app/models/incarico';
import { baseUrl } from '../api-config';


export class QuadroRiassuntivoData {
  dati: { [idGruppo: string]: QuadroRiassuntivoGruppo };
  gruppi: Gruppo[];
}

export class QuadroRiassuntivoGruppo {
  [numMese: number]: DatoQuadroRiassuntivoSingoloMese;
}
export class DatoQuadroRiassuntivoSingoloMese {
  assegnati: number = 0;
  consegnati: number = 0;
  in_lavorazione: number = 0;
}
@Injectable({
  providedIn: 'root'
})
export class QuadroRiassuntivoService {

  count: number;

  constructor(private http: HttpClient) { }

  getQuadroRiassuntivoData(searchParams = {}): Promise<QuadroRiassuntivoData> {
    return this.http.get<QuadroRiassuntivoData>(`${baseUrl}/statistiche/quadro-riassuntivo`,
      { params: { "search": JSON.stringify(searchParams) } }
    ).toPromise();
  }

  async getColonnaIData(SearchParams = {}): Promise<any[]> {
    let res = await this.http.post<any[]>(
      `${baseUrl}/statistiche/colonna-i`, SearchParams
    ).toPromise();

    console.log(res);
    
    this.count = res["count"];
    
    return res["models"];
  }

  getRatioAC(): Promise<number> {
    return this.http.get<number>(`${baseUrl}/statistiche/ac-ratio`).toPromise();
  }
}
